import { ReservationApiEndpoint } from '@core/api-endpoint';
import {
  CancelReservationPayload,
  CancelReservationWithParamsPayload,
  CancelWaitingReservationPayload,
  DeleteCompanionPayload,
  FetchCalendaLotteryReservationListPayload,
  FetchCalendarReservationDetailPayload,
  FetchCalendarReservationDetailResponse,
  FetchCalendarReservationListPayload,
  FetchCalendarReservationListResponse,
  FetchCalendarWaitingReservationListPayload,
  FetchCalendarWaitingReservationListResponse,
  FetchGroupApplicationListPayload,
  FetchGroupApplicationListResponse,
  FetchGroupFormationPayload,
  FetchGroupFormationResponse,
  FetchLotteryCalenderReservationResponse,
  FetchLotteryReservationListPayload,
  FetchLotteryReservationListResponse,
  FetchPenaltyListPayload,
  FetchPenaltyListResponse,
  FetchReservableCountPayload,
  FetchReservableCountResponse,
  FetchReservableStatusPayload,
  FetchReservationDetailPayload,
  FetchReservationDetailResponse,
  FetchReservationListPayload,
  FetchReservationListResponse,
  FetchReservationPenaltyPayload,
  FetchReservationPenaltyResponse,
  FetchWaitingReservationListPayload,
  FetchWaitingReservationListResponse,
  FindIdPayload,
  RequestCompanionListPayload,
  RequestCompanionPayload,
  RequestGroupFormationPayload,
  RequestLotteryReservationListPayload,
  RequestReservationPayload,
  RequestReservationResponse,
  RequestWaitingReservationPayload,
  UpdateAssigneePayload,
  UpdateReservationInfoPayload,
  UpdateReservationPayload,
  FetchRoomListPayload,
  FetchRoomCalendarPayload,
  RequestRoomReservationPayload,
  RoomCalendarItem,
  Room,
  FetchReservedRoomListPayload,
  FetchReservedRoomListResponse,
  CancelRoomReservationPayload,
  FetchRoomPenaltyResponse,
} from '@core/dto';
import { HttpInterface } from '@core/http';
import { ReservationPort } from '@core/ports';
export class ReservationAdapter
  implements
    ReservationPort<
      any,
      | RequestReservationPayload
      | FetchReservationListPayload
      | FetchReservationDetailPayload
      | CancelReservationPayload
      | UpdateReservationPayload
      | UpdateReservationInfoPayload
      | RequestWaitingReservationPayload
      | FetchWaitingReservationListPayload
      | CancelWaitingReservationPayload
      | FetchCalendarReservationListPayload
      | FetchCalendarReservationDetailPayload
      | RequestCompanionPayload
      | DeleteCompanionPayload
      | FormData
      | FindIdPayload
      | FetchReservableStatusPayload
      | FetchGroupFormationPayload
      | RequestGroupFormationPayload
      | FetchGroupApplicationListPayload
      | FetchPenaltyListPayload
      | FetchLotteryReservationListPayload
      | RequestLotteryReservationListPayload
      | FetchCalendaLotteryReservationListPayload
      | FetchRoomCalendarPayload
      | RequestRoomReservationPayload
      | FetchReservedRoomListPayload
      | CancelRoomReservationPayload
    >
{
  http: HttpInterface;
  constructor(httpInstance: HttpInterface) {
    this.http = httpInstance;
  }

  // 실시간 예약
  async requestReservation(
    payload: RequestReservationPayload
  ): Promise<RequestReservationResponse> {
    const response = await this.http.post<RequestReservationResponse>(
      ReservationApiEndpoint.requestReservation,
      payload
    );
    return response.data;
  }

  async fetchReservationList(
    payload: FetchReservationListPayload
  ): Promise<FetchReservationListResponse> {
    const response = await this.http.get<FetchReservationListResponse>(
      ReservationApiEndpoint.fetchReservationList,
      payload
    );
    return response.data;
  }
  async fetchReservationDetail(
    payload: FetchReservationDetailPayload
  ): Promise<FetchReservationDetailResponse> {
    const { reservationId } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.fetchReservationDetail,
      { reservationId }
    );
    const response = await this.http.get<FetchReservationDetailResponse>(url);
    return response.data;
  }
  async fetchPenaltyList(payload: FetchPenaltyListPayload) {
    const response = await this.http.get<FetchPenaltyListResponse>(
      ReservationApiEndpoint.fetchPenaltyList,
      payload
    );
    return response.data;
  }
  async cancelReservation(payload: CancelReservationPayload): Promise<void> {
    const { reservationId } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.cancelReservation,
      {
        reservationId,
      }
    );
    await this.http.delete<void>(url);
  }
  async cancelReservationWithParams(
    payload: CancelReservationWithParamsPayload
  ): Promise<void> {
    const { reservationId, cancelResn } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.cancelReservation,
      {
        reservationId,
      }
    );
    await this.http.put<void>(url, { cancelResn });
  }
  async updateReservation(payload: UpdateReservationPayload): Promise<void> {
    const { reservationId, timeId } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.updateReservation,
      {
        reservationId,
      }
    );
    await this.http.put<void>(url, { timeId });
  }

  async updateReservationInfo(
    payload: UpdateReservationInfoPayload
  ): Promise<void> {
    const { reservationId, ...rest } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.updateReservationInfo,
      {
        reservationId,
      }
    );
    await this.http.put<void>(url, rest);
  }

  // 대기 예약
  async requestWaitingReservation(
    payload: RequestWaitingReservationPayload
  ): Promise<void> {
    await this.http.post<void>(
      ReservationApiEndpoint.requestWaitingReservation,
      payload
    );
  }
  async fetchWaitingReservationList(
    payload: FetchWaitingReservationListPayload
  ): Promise<FetchWaitingReservationListResponse> {
    const response = await this.http.get<FetchWaitingReservationListResponse>(
      ReservationApiEndpoint.fetchWaitingReservationList,
      payload
    );
    return response.data;
  }
  async cancelWaitingReservation(
    payload: CancelWaitingReservationPayload
  ): Promise<void> {
    const { waitingId } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.cancelWaitingReservation,
      {
        waitingId,
      }
    );
    await this.http.delete<void>(url);
  }

  // 예약 달력 조회
  async fetchCalendarReservationList(
    payload: FetchCalendarReservationListPayload
  ): Promise<FetchCalendarReservationListResponse> {
    const response = await this.http.get<FetchCalendarReservationListResponse>(
      ReservationApiEndpoint.fetchCalendarReservationList,
      payload
    );
    return response.data;
  }
  async fetchCalendarWaitingReservationList(
    payload: FetchCalendarWaitingReservationListPayload
  ): Promise<FetchCalendarWaitingReservationListResponse> {
    const response =
      await this.http.get<FetchCalendarWaitingReservationListResponse>(
        ReservationApiEndpoint.fetchCalendarWaitingReservationList,
        payload
      );
    return response.data;
  }
  async fetchCalendarReservationDetail(
    payload: FetchCalendarReservationDetailPayload
  ): Promise<FetchCalendarReservationDetailResponse> {
    const { bsnDate } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.fetchCalendarReservationDetail,
      { bsnDate }
    );
    const response =
      await this.http.get<FetchCalendarReservationDetailResponse>(url);
    return response.data;
  }
  // 예약 동반자
  async requestCompanion(payload: RequestCompanionPayload): Promise<void> {
    const { reservationId, ...rest } = payload;
    const url = this.http.replacedUrl(ReservationApiEndpoint.requestCompanion, {
      reservationId,
    });
    await this.http.post<void>(url, rest);
  }
  async requestCompanionList(payload: {
    reservationId: number;
    cmpnList: RequestCompanionListPayload[];
  }): Promise<void> {
    const { reservationId, cmpnList } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.requestCompanionList,
      {
        reservationId,
      }
    );
    await this.http.post<void>(url, cmpnList);
  }

  async deleteCompanion(payload: DeleteCompanionPayload): Promise<void> {
    const { reservationId, sno } = payload;
    const url = this.http.replacedUrl(ReservationApiEndpoint.deleteCompanion, {
      reservationId,
      sno,
    });
    await this.http.delete<void>(url);
  }
  async fetchReservationPenalty(
    payload: FetchReservationPenaltyPayload
  ): Promise<FetchReservationPenaltyResponse> {
    const { reservationId } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.fetchReservationPenalty,
      {
        reservationId,
      }
    );
    const response = await this.http.get<FetchReservationPenaltyResponse>(url);
    return response.data;
  }
  async requestGroupMemberConfirm(
    payload: FindIdPayload
  ): Promise<{ webId: string }> {
    const response = await this.http.post<{ webId: string }>(
      ReservationApiEndpoint.groupFindId,
      payload
    );
    return response.data;
  }
  async requestFormGroupReservation(payload: FormData): Promise<void> {
    await this.http.post<void>(ReservationApiEndpoint.group, payload);
  }
  async fetchGroupApplication(
    payload: FetchGroupApplicationListPayload
  ): Promise<FetchGroupApplicationListResponse> {
    const response = await this.http.get<FetchGroupApplicationListResponse>(
      ReservationApiEndpoint.group,
      payload
    );
    return response.data;
  }
  async deleteGroupApplication(payload: {
    grpRequestId: number;
  }): Promise<void> {
    const { grpRequestId } = payload;
    const url = this.http.replacedUrl(ReservationApiEndpoint.deleteGroup, {
      grpRequestId,
    });
    await this.http.delete<void>(url);
  }
  async fetchReservableStatus(
    payload: FetchReservableStatusPayload
  ): Promise<boolean> {
    const { timeId } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.fetchReservableStatus,
      {
        timeId,
      }
    );
    const response = await this.http.get<boolean>(url);
    return response.data;
  }
  async fetchReservableCount(
    payload: FetchReservableCountPayload
  ): Promise<FetchReservableCountResponse> {
    const response = await this.http.get<FetchReservableCountResponse>(
      ReservationApiEndpoint.fetchReservableCount,
      payload
    );
    return response.data;
  }
  async fetchGroupFormation(
    payload: FetchGroupFormationPayload
  ): Promise<FetchGroupFormationResponse> {
    const { resveNo } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.fetchGroupReservation,
      {
        resveNo,
      }
    );
    const response = await this.http.get<FetchGroupFormationResponse>(url);
    return response.data;
  }
  async requestGroupFormation(
    payload: RequestGroupFormationPayload
  ): Promise<void> {
    const { resveNo, requestGroupFormation } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.requestGroupFormation,
      {
        resveNo,
      }
    );
    await this.http.post<void>(url, requestGroupFormation);
  }
  async requestLotteryReservation(
    payload: RequestLotteryReservationListPayload
  ): Promise<void> {
    await this.http.post<void>(
      ReservationApiEndpoint.requestLotteryReservation,
      payload
    );
  }
  async fetchLotteryReservationList(
    payload: FetchLotteryReservationListPayload
  ): Promise<FetchLotteryReservationListResponse> {
    const response = await this.http.get<FetchLotteryReservationListResponse>(
      ReservationApiEndpoint.fetchLotteryReservation,
      payload
    );
    return response.data;
  }
  async deleteLotteryReservation(payload: {
    lotteryId: number;
  }): Promise<void> {
    const { lotteryId } = payload;
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.deleteLotteryReservation,
      {
        lotteryId,
      }
    );
    await this.http.delete<void>(url);
  }
  async fetchLotteryReservationCalender(
    payload: FetchCalendaLotteryReservationListPayload
  ): Promise<FetchLotteryCalenderReservationResponse> {
    const response =
      await this.http.get<FetchLotteryCalenderReservationResponse>(
        ReservationApiEndpoint.fetchLotteryReservationCalender,
        payload
      );
    return response.data;
  }
  async updateAssignee(payload: UpdateAssigneePayload): Promise<void> {
    const { reservationId, ...rest } = payload;
    const url = this.http.replacedUrl(ReservationApiEndpoint.updateAssignee, {
      reservationId,
    });
    await this.http.put<void>(url, rest);
  }

  async fetchRoomList(payload: FetchRoomListPayload): Promise<Room[]> {
    const response = await this.http.get<Room[]>(
      ReservationApiEndpoint.fetchRoomList,
      payload
    );
    return response.data;
  }

  async fetchRoomCalendar(
    payload: FetchRoomCalendarPayload
  ): Promise<RoomCalendarItem[]> {
    const response = await this.http.get<RoomCalendarItem[]>(
      ReservationApiEndpoint.fetchRoomCalendar,
      payload
    );
    return response.data;
  }
  async requestRoomReservation(
    payload: RequestRoomReservationPayload
  ): Promise<void> {
    await this.http.post<void>(
      ReservationApiEndpoint.requestRoomReservation,
      payload
    );
  }
  async fetchReservedRoomList(
    payload: FetchReservedRoomListPayload
  ): Promise<FetchReservedRoomListResponse> {
    const response = await this.http.get<FetchReservedRoomListResponse>(
      ReservationApiEndpoint.fetchReservedRoomList,
      payload
    );
    return response.data;
  }
  async cancelRoomReservation(
    payload: CancelRoomReservationPayload
  ): Promise<void> {
    const url = this.http.replacedUrl(
      ReservationApiEndpoint.cancelRoomReservation,
      {
        stayId: payload.stayId,
      }
    );
    await this.http.put<void>(url);
  }
  async fetchRoomPenalty(
    payload: CancelRoomReservationPayload
  ): Promise<FetchRoomPenaltyResponse> {
    const url = this.http.replacedUrl(ReservationApiEndpoint.fetchRoomPenalty, {
      stayId: payload.stayId,
    });
    const response = await this.http.get<FetchRoomPenaltyResponse>(url);
    return response.data;
  }
}
